// Configuración del entorno
export const ENVIRONMENT = {
  // URLs del backend
  BACKEND_HTTPS: 'https://localhost:7028',
  BACKEND_HTTP: 'http://localhost:7028',  // Actualizado al puerto correcto
  
  // Configuración de desarrollo
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // URL base según el entorno
  get API_URL() {
    if (this.IS_DEVELOPMENT) {
      // En desarrollo, usar URL absoluta del backend directamente
      // Usar HTTPS porque el backend está configurado en el puerto 7028 con HTTPS
      return this.BACKEND_HTTPS; // 'https://localhost:7028'
    } else if (this.IS_PRODUCTION) {
      return 'https://requiplusdemo.tangentemexico.com';
    } else {
      // Fallback: usar URL del backend HTTP
      return this.BACKEND_HTTP;
    }
  }
};

export default ENVIRONMENT;
